<template>
  <screen
    v-show="show"
    :screen-info="$t('thingstonote.wear_tight')"
    :can-leave="false"
    @skip="$emit('skip')"
  >
    <div class="w-full" ref="animation"></div>
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import animation from '@/mixins/animation';
import wearTight from '@/assets/animations/wear_tight.json';
import Screen from '../common/Screen.vue';

export default {
  name: 'WearTight',
  components: {
    Screen,
  },
  mixins: [autoNext, animation],
  data: () => ({
    duration: 5,
    audioKey: '6-Skin_tight',
    animationData: wearTight,
  }),
};
</script>
